import React, { useState, useEffect } from 'react';
import { useSaga } from 'use-reducer-saga';
import { ToastNotification } from 'carbon-components-react';
import { PartialHeaderLeftSideNoPanelLayout } from 'layouts/partialHeader.leftSideNoPanel.layout';
import { LocalDispatchContext, LocalStoreContext } from './localStore/context';
import reducer, { initialState } from './localStore/reducer';
import sagas from './localStore/sagas';
import UsersList from './components/usersList';
import UserDetailsModal from './components/userDetails';

export const SysAdminFreePlan: React.FC = () => {
  const [localStore, localDispatch] = useSaga(reducer, initialState, sagas);
  const [showDetailsModal, setShowDetailsModal] = useState<boolean>(false);
  const [selectedUserId, setSelectedUserId] = useState<number>(0);
  const [showToastNotification, setShowToastNotification] =
    useState<boolean>(false);
  const [toastNotificationData, setToastNotificationData] = useState<any>(null);

  const handleUserDetailsModalClose = () => {
    setSelectedUserId(0);
    setShowDetailsModal(false);
  };

  const handleToastNotificationClose: Function = () => {
    setToastNotificationData(null);
    setShowToastNotification(false);
  };

  useEffect(() => {
    if (selectedUserId > 0) {
      setShowDetailsModal(true);
    } else {
      setShowDetailsModal(false);
    }
  }, [selectedUserId]);

  return (
    <LocalStoreContext.Provider value={localStore}>
      <LocalDispatchContext.Provider value={localDispatch}>
        <div
          id="SysAdminFreePlanUsers"
          data-testid="SysAdminFreePlanUsers"
          className="sys-admin-free-plan-users"
        >
          {showToastNotification && toastNotificationData && (
            <ToastNotification
              kind={toastNotificationData.kind}
              lowContrast
              caption=""
              iconDescription=""
              subtitle={toastNotificationData.subtitle}
              timeout={toastNotificationData.kind === 'error' ? 5000 : 3000}
              className={
                toastNotificationData.kind === 'error' ? 'toast-error' : 'toast'
              }
              title={
                toastNotificationData.kind === 'error' ? 'Error occurred' : ''
              }
              onCloseButtonClick={() => handleToastNotificationClose()}
              onClose={() => handleToastNotificationClose()}
            />
          )}
          <PartialHeaderLeftSideNoPanelLayout
            enableHeaderGlobalBar={false}
            showLeftHandSideNav={true}
          >
            {showDetailsModal && (
              <UserDetailsModal
                selectedUserId={selectedUserId}
                onClose={() => handleUserDetailsModalClose()}
                setToastNotificationData={setToastNotificationData}
                setShowToastNotification={setShowToastNotification}
              />
            )}
            <UsersList
              setSelectedUserId={setSelectedUserId}
              selectedUserId={selectedUserId}
            />
          </PartialHeaderLeftSideNoPanelLayout>
        </div>
      </LocalDispatchContext.Provider>
    </LocalStoreContext.Provider>
  );
};

export default React.memo(SysAdminFreePlan);
